import React from 'react';
import { useTranslation } from 'react-i18next';

interface ProjectNotesGuidanceProps {
  id: string;
  // On the create page, tell where the notes are found after the project exists.
  showWhereToFind?: boolean;
}

const EXAMPLE_KEYS = ['staffing', 'systems', 'purchasing', 'reminders'] as const;

/**
 * Explains the project "Övrigt" field: internal notes for the company that the
 * customer never sees, with concrete examples. Shared by the create page and
 * the project's edit tab so both describe the field the same way.
 */
export function ProjectNotesGuidance({ id, showWhereToFind = false }: ProjectNotesGuidanceProps) {
  const { t } = useTranslation();
  return (
    <div id={id} className="form-text mb-2" data-testid="project-notes-guidance">
      {/* divs, not p: the theme gives <p> its own font size, which would make the
          intro larger than the list; divs inherit the form-text size. */}
      <div className="mb-1">
        <i className="feather-lock me-1" aria-hidden="true"></i>
        {t('projects.form.notesGuidance.intro')}
      </div>
      <ul className="mb-1 ps-3">
        {EXAMPLE_KEYS.map(key => (
          <li key={key}>{t(`projects.form.notesGuidance.examples.${key}`)}</li>
        ))}
      </ul>
      {showWhereToFind && <div>{t('projects.form.notesGuidance.whereToFind')}</div>}
    </div>
  );
}
